import { Bytes } from '../enum';
import { AppConstants } from '@apps/app.constants';

export class ConvertService
{
    // * See https://en.wikipedia.org/wiki/Kilobyte
    // * See also https://fr.wikipedia.org/wiki/Pr%C3%A9fixe_binaire
    private static units = [
        'NUMBERS.UNITS.BINARY.BYTE',
        'NUMBERS.UNITS.BINARY.KIBI',
        'NUMBERS.UNITS.BINARY.MEBI',
        'NUMBERS.UNITS.BINARY.GIBI',
        'NUMBERS.UNITS.BINARY.TEBI',
        'NUMBERS.UNITS.BINARY.PEBI'
    ];

    public static convert (value: number, sourceUnit: Bytes, targetUnit: Bytes): number
    {
        if (targetUnit < sourceUnit)
        {
            throw RangeError;
        }

        return value / (Math.pow(AppConstants.MilleVingtQuatre, (targetUnit - sourceUnit)));
    }

    /**
     * Retourne le rang de la meilleure unité afin que la conversion donne un nombre dans l'intervalle [0, 10000[
     * @param {number} value: nombre dont on  veut la meilleure unité, valeur en bytes par défaut
     * @returns {number}
     */
    public static calcBestBytesUnit (value: number): number
    {
        let tmp: number = value;
        let iter: number = 0;

        do
        {
            iter++;
            tmp = tmp / AppConstants.MilleVingtQuatre;
        } while (tmp > 1);

        return iter - 1;
    }

    /**
     *
     * @param {number} min : Le nombre minimum de la série
     * @param {number} max : Le nombre maximum de la série
     */
    public static toIntelligentBytesUnits (min: number, max: number): { min: number, max: number, unit: string, power: number, indexUnit: number }
    {
        let maxUnit = ConvertService.calcBestBytesUnit(max);
        let p = Math.pow(AppConstants.MilleVingtQuatre, maxUnit);

        if (min / p < 1 && max / p > 1000)
        {
            maxUnit -= 1;
        }

        maxUnit = Math.max(0, maxUnit);
        p = Math.pow(AppConstants.MilleVingtQuatre, maxUnit);
        return {
            min: min / p,
            max: max / p,
            unit: ConvertService.units[maxUnit],
            power: p,
            indexUnit: maxUnit
        };
    }
}
